import React from 'react';
import LeafletMap from './LeafletMap';

// Visitor locations on an interactive OpenStreetMap (no API key).
export default function VisitorMap({ locations = [] }) {
  const markers = (locations || [])
    .filter((l) => typeof l.lat === 'number' && typeof l.lng === 'number')
    .map((l) => ({
      lat: l.lat,
      lng: l.lng,
      count: l.count,
      label: [l.city, l.country].filter(Boolean).join(', ') || 'Unknown',
    }));

  return (
    <div className="bg-white rounded-lg p-4 shadow-sm border" style={{ borderColor: 'rgba(0,0,0,0.08)' }} data-testid="visitor-map">
      <div className="flex items-center justify-between mb-3">
        <h4 className="font-title text-sm" style={{ color: 'var(--navy)' }}>Where visitors are coming from</h4>
        <span className="text-xs" style={{ color: 'var(--olive)' }}>{markers.length} location{markers.length === 1 ? '' : 's'}</span>
      </div>
      <LeafletMap markers={markers} center={[20, 10]} zoom={2} height={420} testid="visitor-leaflet-map" />
      {markers.length === 0 && (
        <p className="text-xs mt-2" style={{ color: 'var(--olive)' }}>No mapped locations yet. Views from private/local networks aren’t geolocated.</p>
      )}
    </div>
  );
}
